import { CONTACT_US_PROVIDERS } from './contactUs.constants';

/**
 * Send the company name and return the matching company id from
 * CONTACT_US_PROVIDERS. `excludedIds` skips providers already assigned
 * to a previous item in the same response. Sinces name is the main identifier
 * defined in contentful, this needs to be considered when matching name to id.
 */
const matchContactUsCompanyIdByName = (companyName, excludedIds = []) => {
  const match = CONTACT_US_PROVIDERS.find(
    (prov) => prov.name && companyName
      && prov.name.toLowerCase() === companyName.toLowerCase()
      && !excludedIds.includes(prov.id),
  );

  return match?.id;
};

/**
 * Maps a list of contact-us items (each with a `CompanyName` field) to
 * include a resolved `companyId`, assigning duplicate-named companies
 * (see matchContactUsCompanyIdByName) as identifier.
 */
const assignContactUsCompanyIds = (items) => {
  const usedIds = [];

  return items.map((item) => {
    const companyId = matchContactUsCompanyIdByName(item.CompanyName, usedIds);

    if (companyId !== undefined) {
      usedIds.push(companyId);
    }

    return { ...item, companyId };
  });
};

export { assignContactUsCompanyIds, matchContactUsCompanyIdByName };
